import React from "react";

const ErrorPage = () => {
  return <div>404</div>;
};

export default ErrorPage;
